import React from 'react';
import {Outlet} from 'react-router';

import {Footer} from '../Footer/Footer';
import {Header} from '../Header/Header';

import cls from './Layout.module.scss';

const Layout = () => (
    <div className={cls.layout}>

        <div className={cls.header}>
            <div className={'content'}>
                <Header/>
            </div>
        </div>

        <div className={cls.content}>
            <div className={'content'}>
                <Outlet/>
            </div>
        </div>

        <Footer/>

    </div>
)

export default Layout